module.exports = __webpack_public_path__ + "img/lemon-stylus.3e06470a.jpg";